import React, { useRef, useState } from "react";
import profilePlaceholder from "../../assets/svgs/dummy_image.svg";
import profile_image_editing from "../../assets/svgs/profile_image_editing.svg";
import { profileImageSectionStyle as styles } from "./myContact.tailwind";
import { saveProfileImage } from '../../redux/slices/updateUserSlice';
import { connect } from 'react-redux';

const ProfileImageSection = ({ user, userPointsAndRewards, saveProfileImage }) => {
  const fileInputRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [profileImageError, setProfileImageError] = useState(false);
  
  const { userDetails: profileData } = user || {};
  const { userTotalEarnedPoints: lifetimePoints, userTotalAvailablePoints: availablePoints } = userPointsAndRewards || {};
  
  // const [profileImage, setProfileImage] = useState(profilePlaceholder);
  // const [profileImage, setProfileImage] = useState({profileImageUrl: profileData?.profileImageUrl || profilePlaceholder});

  // Define allowed file extensions and maximum file size
  const allowedExtensions = process.env?.REACT_APP_ALLOWED_IMAGE_EXTENSIONS?.split(",");
  const maxFileSizeMB = parseFloat(process.env?.REACT_APP_MAX_ALLOWED_IMAGE_SIZE_MB);

  // Validates the selected file based on the allowed extensions and maximum size limit.
  const validateFile = (file) => {
    if (!file) return false;

    const fileExtension = file?.name?.split(".")?.pop()?.toLowerCase();
    
    if (!allowedExtensions?.includes(fileExtension)) {
      setErrorMessage(`Invalid file type. Allowed types are: ${allowedExtensions.join(', ')}`);
      return false;
    }

    const fileSizeMB = file?.size / (1024 * 1024);
    if (fileSizeMB > maxFileSizeMB) {
      setErrorMessage(`File size exceeds the maximum size limit of ${maxFileSizeMB}MB`);
      return false;
    }

    setErrorMessage(""); // Clear any existing errors if validation passes
    return true;
  };

  // Handles image selection from the file input.
  const handleImageSelect = async (event) => {
    const profileImageFile = event.target.files[0];
    
    if (validateFile(profileImageFile)) {
      // Pass the file object directly to Redux
      saveProfileImage({ profileImageUrl: profileImageFile });
    }
  };
  

  return (
    <div className={styles.outerContainer}>
      <div className={styles.profileImageContainer}>
        <div className={styles.profileImage}>
          <div className="relative rounded-[50%]">
            { profileData?.profileImageUrl && !profileImageError ? (
              <img src={profileData?.profileImageUrl} alt="Profile" className={styles.profileImage} onError={() => setProfileImageError(true)}/>
            ) : (
              // Default Profile Image
              <img src={profilePlaceholder} alt="Profile" className={styles.profileImage} />
            )}
            {/* Profile Image */}
            
            {/* Edit Image Button */}
            <button className={styles.editButton} onClick={() => fileInputRef.current.click()}>
              <img src={profile_image_editing} alt="Edit Icon" className={styles.editIconImage} />
            </button>
            {/* Select File Input */}
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept={allowedExtensions.map((ext) => `.${ext.trim()}`).join(", ")}
              onChange={handleImageSelect}
            />
          </div>
          {errorMessage && (
            <p className={styles.errorText}>{errorMessage}</p>
          )}
        </div>
      </div>
      {/* User Profile Information */}
      <div className={styles.informationContainer}>
        {/* User Name */}
        <h1 className={styles.userNameText}>{profileData?.userNickName}</h1>
        {/* User Email */}
        <p className={styles.userEmail}>{profileData?.userEmail}</p>
        {/* Points (Lifetime Points and Available Points) */}
        <div className={styles.pointsContainer}>
          <div className={styles.pointSection}>
            <span className={styles.pointsHeading}>Lifetime Points</span>
            <span className={styles.pointsValue}>{lifetimePoints}</span>
          </div>
          <div className={styles.divider}></div>
          <div className={styles.pointSection}>
            <span className={styles.pointsHeading}>Available Points</span>
            <span className={styles.pointsValue}>{availablePoints}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  saveProfileImage: (imageData) => dispatch(saveProfileImage(imageData)), // Pass the image URL and file to Redux
});

export default connect(null, mapDispatchToProps)(ProfileImageSection);
